// import { apiService } from './apiService';
// import apiClient from './apiService';

// import {
//   PurchaseOrder,
//   PurchaseOrderCreate,
//   PurchaseOrderUpdate,
//   PurchaseOrderFilters,
//   PurchaseOrderStats,
//   GoodsReceived,
//   GoodsReceivedCreate,
//   PurchaseOrderStatus
// } from '../types/purchaseOrder';

// const base = '/purchase';

// export const purchaseOrderService = {
//   // Purchase Orders
//   async getPurchaseOrders(params?: {
//     skip?: number;
//     limit?: number;
//     status?: PurchaseOrderStatus;
//     location_id?: number;
//   }): Promise<PurchaseOrder[]> {
//     return apiService.get<PurchaseOrder[]>(`${base}/orders/`, params);
//   },

//   async getPurchaseOrder(id: number): Promise<PurchaseOrder> {
//     return apiService.get<PurchaseOrder>(`${base}/orders/${id}`);
//   },

//   async createPurchaseOrder(data: PurchaseOrderCreate): Promise<PurchaseOrder> {
//     return apiService.post<PurchaseOrder>(`${base}/orders/`, data);
//   },

//   async updatePurchaseOrder(id: number, data: PurchaseOrderUpdate): Promise<PurchaseOrder> {
//     return apiService.put<PurchaseOrder>(`${base}/orders/${id}`, data);
//   },

//   async deletePurchaseOrder(id: number): Promise<void> {
//     await apiService.delete<void>(`${base}/orders/${id}`);
//   },

//   // Status Management
//   async sendPurchaseOrder(id: number): Promise<{ message: string; po_number: string }> {
//     return apiService.put<{ message: string; po_number: string }>(`${base}/orders/${id}/send`);
//   },

//   async updatePurchaseOrderStatus(
//     id: number, 
//     newStatus: string
//   ): Promise<{
//     message: string;
//     success: boolean;
//     old_status: string;
//     new_status: string;
//     email_sent: boolean;
//     goods_received_created: boolean;
//     triggers: {
//       email_triggered: boolean;
//       goods_received_triggered: boolean;
//     };
//   }> {
//     const response = await apiClient.put(`${base}/orders/${id}/status`, null, {
//       params: { new_status: newStatus }
//     });
//     return response.data;
//   },

//   // Goods Received
//   async getGoodsReceived(params?: {
//     skip?: number;
//     limit?: number;
//     po_id?: number;
//   }): Promise<GoodsReceived[]> {
//     return apiService.get<GoodsReceived[]>(`${base}/goods-received/`, params);
//   },

//   async getGoodsReceivedById(id: number): Promise<GoodsReceived> {
//     return apiService.get<GoodsReceived>(`${base}/goods-received/${id}`);
//   },

//   async createGoodsReceived(data: GoodsReceivedCreate): Promise<GoodsReceived> {
//     return apiService.post<GoodsReceived>(`${base}/goods-received/`, data);
//   },

//   async updateGoodsReceived(id: number, data: Partial<GoodsReceivedCreate>): Promise<GoodsReceived> {
//     return apiService.put<GoodsReceived>(`${base}/goods-received/${id}`, data);
//   },

//   // Statistics and Analytics
//   async getPurchaseOrderStats(params?: {
//     location_id?: number;
//     date_from?: string;
//     date_to?: string;
//   }): Promise<PurchaseOrderStats> {
//     return apiService.get<PurchaseOrderStats>(`${base}/orders/stats/`, params);
//   },

//   // Search and Filter
//   async searchPurchaseOrders(filters: PurchaseOrderFilters): Promise<PurchaseOrder[]> {
//     return apiService.get<PurchaseOrder[]>(`${base}/orders/search/`, filters as any);
//   },

//   // Export functionality
//   async exportPurchaseOrders(format: 'pdf' | 'excel', filters?: PurchaseOrderFilters): Promise<Blob> {
//     const response = await apiClient.get(`${base}/orders/export/`, {
//       params: { ...(filters || {}), format },
//       responseType: 'blob'
//     });
//     return response.data;
//   },

//   async exportPurchaseOrder(id: number, format: 'pdf' | 'excel'): Promise<Blob> {
//     const response = await apiClient.get(`${base}/orders/${id}/export/`, {
//       params: { format },
//       responseType: 'blob'
//     });
//     return response.data;
//   }
// };

// // Helper functions
// export const purchaseOrderHelpers = {
//   getStatusColor(status: PurchaseOrderStatus): string {
//     const colors = {
//       [PurchaseOrderStatus.DRAFT]: '#8c8c8c',
//       [PurchaseOrderStatus.SENT]: '#1890ff',
//       [PurchaseOrderStatus.RECEIVED]: '#52c41a',
//       [PurchaseOrderStatus.CANCELLED]: '#ff4d4f',
//     };
//     return colors[status] || '#8c8c8c';
//   },

//   getStatusText(status: PurchaseOrderStatus): string {
//     const texts = {
//       [PurchaseOrderStatus.DRAFT]: 'Draft',
//       [PurchaseOrderStatus.SENT]: 'Sent',
//       [PurchaseOrderStatus.RECEIVED]: 'Received',
//       [PurchaseOrderStatus.CANCELLED]: 'Cancelled',
//     };
//     return texts[status] || status;
//   },

//   formatCurrency(amount: number): string {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount);
//   },

//   formatDate(dateString: string): string {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   },

//   calculateOrderTotal(items: Array<{ quantity: number; unit_price: number }>): number {
//     return items.reduce((total, item) => total + (item.quantity * item.unit_price), 0);
//   },

//   getOrderProgress(items: Array<{ quantity: number; received_quantity: number }>): number {
//     const totalOrdered = items.reduce((sum, item) => sum + item.quantity, 0);
//     const totalReceived = items.reduce((sum, item) => sum + item.received_quantity, 0);
//     return totalOrdered > 0 ? (totalReceived / totalOrdered) * 100 : 0;
//   },

//   canEditOrder(status: PurchaseOrderStatus): boolean {
//     return status === PurchaseOrderStatus.DRAFT;
//   },

//   canSendOrder(status: PurchaseOrderStatus): boolean {
//     return status === PurchaseOrderStatus.DRAFT;
//   },

//   canReceiveOrder(status: PurchaseOrderStatus): boolean {
//     return status === PurchaseOrderStatus.SENT;
//   },

//   canCancelOrder(status: PurchaseOrderStatus): boolean {
//     return status !== PurchaseOrderStatus.RECEIVED && status !== PurchaseOrderStatus.CANCELLED;
//   }
// };

// export default purchaseOrderService;


import { apiService } from './apiService';
import apiClient from './apiService';

import {
  PurchaseOrder,
  PurchaseOrderCreate,
  PurchaseOrderUpdate,
  PurchaseOrderFilters,
  PurchaseOrderStats,
  GoodsReceived,
  GoodsReceivedCreate,
  PurchaseOrderStatus
} from '../types/purchaseOrder';

const base = '/purchase';

export const purchaseOrderService = {
  // Purchase Orders
  async getPurchaseOrders(params?: {
    skip?: number;
    limit?: number;
    status?: PurchaseOrderStatus;
    location_id?: number;
  }): Promise<PurchaseOrder[]> {
    return apiService.get<PurchaseOrder[]>(`${base}/orders/`, params);
  },

  async getPurchaseOrder(id: number): Promise<PurchaseOrder> {
    // Add cache-busting to ensure fresh data
    const timestamp = Date.now();
    return apiService.get<PurchaseOrder>(`${base}/orders/${id}?_t=${timestamp}`);
  },

  async createPurchaseOrder(data: PurchaseOrderCreate): Promise<PurchaseOrder> {
    return apiService.post<PurchaseOrder>(`${base}/orders/`, data);
  },

  async updatePurchaseOrder(id: number, data: PurchaseOrderUpdate): Promise<PurchaseOrder> {
    return apiService.put<PurchaseOrder>(`${base}/orders/${id}`, data);
  },

  async deletePurchaseOrder(id: number): Promise<void> {
    await apiService.delete<void>(`${base}/orders/${id}`);
  },

  // Status Management - FIXED VERSION
  /**
   * Send PO to vendor via email
   * This changes status from DRAFT to SENT and triggers email
   */
  async sendPurchaseOrderEmail(id: number): Promise<{
    success: boolean;
    message: string;
    po_number: string;
    old_status: string;
    new_status: string;
    email_sent: boolean;
    email_triggered: boolean;
  }> {
    try {
      console.log(`📧 Sending PO ${id} to vendor...`);
      
      // POST request to send email endpoint
      const response = await apiClient.post(`${base}/orders/${id}/send-email`, {});
      
      console.log('✅ Email API response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Failed to send email:', error);
      const detail = error.response?.data?.detail || error.message || 'Failed to send email to vendor';
      throw new Error(detail);
    }
  },

  /**
   * Update PO status manually
   * FIXED: Now sends new_status in request body instead of query params
   */
  async updatePurchaseOrderStatus(
    id: number, 
    newStatus: string
  ): Promise<{
    success: boolean;
    message: string;
    old_status: string;
    new_status: string;
    email_sent: boolean;
    email_triggered: boolean;
    goods_received_created: boolean;
    goods_received_triggered: boolean;
  }> {
    try {
      console.log(`🔄 Updating PO ${id} status to: ${newStatus}`);
      
      // FIXED: Send as request body, not query params
      const response = await apiClient.patch(`${base}/orders/${id}/status`, {
        new_status: newStatus
      });
      
      console.log('✅ Status update response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Status update failed:', error);
      throw new Error(error.response?.data?.detail || 'Failed to update status');
    }
  },

  /**
   * Debug endpoint to check actual PO state in database
   */
  async debugPurchaseOrder(id: number): Promise<{
    po_id: number;
    po_number: string;
    current_status: string;
    vendor_name: string;
    total_amount: number;
  }> {
    try {
      const response = await apiClient.get(`${base}/orders/${id}/debug`);
      console.log('🔍 Debug info:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Debug failed:', error);
      throw error;
    }
  },

  // Legacy method - kept for backward compatibility
  async sendPurchaseOrder(id: number): Promise<{ message: string; po_number: string }> {
    console.warn('⚠️  Using legacy sendPurchaseOrder - use sendPurchaseOrderEmail instead');
    return apiService.put<{ message: string; po_number: string }>(`${base}/orders/${id}/send`);
  },

  // Goods Received
  async getGoodsReceived(params?: {
    skip?: number;
    limit?: number;
    po_id?: number;
  }): Promise<GoodsReceived[]> {
    return apiService.get<GoodsReceived[]>(`${base}/goods-received/`, params);
  },

  async getGoodsReceivedById(id: number): Promise<GoodsReceived> {
    return apiService.get<GoodsReceived>(`${base}/goods-received/${id}`);
  },

  async createGoodsReceived(data: GoodsReceivedCreate): Promise<GoodsReceived> {
    return apiService.post<GoodsReceived>(`${base}/goods-received/`, data);
  },

  async updateGoodsReceived(id: number, data: Partial<GoodsReceivedCreate>): Promise<GoodsReceived> {
    return apiService.put<GoodsReceived>(`${base}/goods-received/${id}`, data);
  },

  async completeGoodsReceived(id: number): Promise<{ message: string; grpo_number: string }> {
    return apiService.put<{ message: string; grpo_number: string }>(`${base}/goods-received/${id}/complete`);
  },

  async deleteGoodsReceived(id: number): Promise<{ message: string }> {
    return apiService.delete<{ message: string }>(`${base}/goods-received/${id}`);
  },

  async getPendingReceipts(params?: { skip?: number; limit?: number }): Promise<PurchaseOrder[]> {
    return apiService.get<PurchaseOrder[]>(`${base}/pending-receipts/`, params);
  },

  // Statistics and Analytics
  async getPurchaseOrderStats(params?: {
    location_id?: number;
    date_from?: string;
    date_to?: string;
  }): Promise<PurchaseOrderStats> {
    return apiService.get<PurchaseOrderStats>(`${base}/orders/stats/`, params);
  },

  // Search and Filter
  async searchPurchaseOrders(filters: PurchaseOrderFilters): Promise<PurchaseOrder[]> {
    return apiService.get<PurchaseOrder[]>(`${base}/orders/search/`, filters as any);
  },

  // Export functionality
  async exportPurchaseOrders(format: 'pdf' | 'excel', filters?: PurchaseOrderFilters): Promise<Blob> {
    const response = await apiClient.get(`${base}/orders/export/`, {
      params: { ...(filters || {}), format },
      responseType: 'blob'
    });
    return response.data;
  },

  async exportPurchaseOrder(id: number, format: 'pdf' | 'excel'): Promise<Blob> {
    const response = await apiClient.get(`${base}/orders/${id}/export/`, {
      params: { format },
      responseType: 'blob'
    });
    return response.data;
  },

  /**
   * Bulk PO from Excel: upload file and parse items (review before create).
   */
  async uploadPoExcel(
    file: File,
    vendor_id: number,
    location_id: number,
    expected_delivery_date?: string,
    notes?: string
  ): Promise<{
    success: boolean;
    total_rows: number;
    valid_items: any[];
    invalid_items: any[];
    errors: string[];
    suggested_po_data: any | null;
  }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('vendor_id', String(vendor_id));
    formData.append('location_id', String(location_id));
    if (expected_delivery_date) formData.append('expected_delivery_date', expected_delivery_date);
    if (notes) formData.append('notes', notes);
    return apiService.post<any>(`${base}/orders/upload-excel`, formData);
  },

  /**
   * Create a single PO from parsed Excel data (from uploadPoExcel suggested_po_data).
   */
  async createPoFromExcel(poData: any): Promise<PurchaseOrder> {
    return apiService.post<PurchaseOrder>(`${base}/orders/create-from-excel`, poData);
  }
};

// Helper functions
export const purchaseOrderHelpers = {
  getStatusColor(status: PurchaseOrderStatus): string {
    const colors = {
      [PurchaseOrderStatus.DRAFT]: '#8c8c8c',
      [PurchaseOrderStatus.SENT]: '#1890ff',
      [PurchaseOrderStatus.RECEIVED]: '#52c41a',
      [PurchaseOrderStatus.CANCELLED]: '#ff4d4f',
    };
    return colors[status] || '#8c8c8c';
  },

  getStatusText(status: PurchaseOrderStatus): string {
    const texts = {
      [PurchaseOrderStatus.DRAFT]: 'Draft',
      [PurchaseOrderStatus.SENT]: 'Pending',
      [PurchaseOrderStatus.RECEIVED]: 'Completed',
      [PurchaseOrderStatus.CANCELLED]: 'Cancelled',
    };
    return texts[status] || status;
  },

  quantities(order: { items?: Array<{ quantity?: number; received_quantity?: number }>; order_items?: Array<{ quantity?: number; received_quantity?: number }> }) {
    const items = order.items || order.order_items || [];
    const ordered = items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    const received = items.reduce((sum, item) => sum + (Number(item.received_quantity) || 0), 0);
    const remaining = Math.max(0, ordered - received);
    return { ordered, received, remaining };
  },

  isPartiallyReceived(order: { status?: string; items?: Array<{ quantity?: number; received_quantity?: number }>; order_items?: Array<{ quantity?: number; received_quantity?: number }> }): boolean {
    if (String(order.status) !== PurchaseOrderStatus.SENT) return false;
    const { received, remaining } = purchaseOrderHelpers.quantities(order);
    return received > 0 && remaining > 0;
  },

  displayStatus(order: { status: string; items?: Array<{ quantity?: number; received_quantity?: number }>; order_items?: Array<{ quantity?: number; received_quantity?: number }> }): { text: string; color: string } {
    if (purchaseOrderHelpers.isPartiallyReceived(order)) {
      return { text: 'Partially received', color: 'orange' };
    }
    const colors: Record<string, string> = {
      [PurchaseOrderStatus.DRAFT]: 'default',
      [PurchaseOrderStatus.SENT]: 'processing',
      [PurchaseOrderStatus.RECEIVED]: 'success',
      [PurchaseOrderStatus.CANCELLED]: 'error',
    };
    return {
      text: purchaseOrderHelpers.getStatusText(order.status as PurchaseOrderStatus),
      color: colors[order.status] || 'default',
    };
  },

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  },

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  },

  calculateOrderTotal(items: Array<{ quantity: number; unit_price: number }>): number {
    return items.reduce((total, item) => total + (item.quantity * item.unit_price), 0);
  },

  getOrderProgress(items: Array<{ quantity: number; received_quantity: number }>): number {
    const totalOrdered = items.reduce((sum, item) => sum + item.quantity, 0);
    const totalReceived = items.reduce((sum, item) => sum + item.received_quantity, 0);
    return totalOrdered > 0 ? (totalReceived / totalOrdered) * 100 : 0;
  },

  canEditOrder(status: PurchaseOrderStatus): boolean {
    return status === PurchaseOrderStatus.DRAFT;
  },

  canSendOrder(status: PurchaseOrderStatus): boolean {
    return status === PurchaseOrderStatus.DRAFT;
  },

  canReceiveOrder(status: PurchaseOrderStatus): boolean {
    return status === PurchaseOrderStatus.SENT;
  },

  canCancelOrder(status: PurchaseOrderStatus): boolean {
    return status !== PurchaseOrderStatus.RECEIVED && status !== PurchaseOrderStatus.CANCELLED;
  }
};

export default purchaseOrderService;